package org.hs_soft.runmynesto.data.local_datasource.local_storage.home

import kotlinx.browser.window
import org.hs_soft.runmynesto.domain.repository.local_datasource.home.SetNewCustomerRepository
import org.hs_soft.runmynesto.domain.util.IdUtils

class SetIsNewCustomerRepositoryImpl:SetNewCustomerRepository
{

    override suspend fun setNewCustomer(newCustomer: Boolean) {
        window.sessionStorage.setItem(IdUtils.companyName, newCustomer.toString())

    }
}